module.exports = __webpack_public_path__ + "img/ppt.7dd7c063.png";